/* ---------------------------------------------------------------------------
   KANVA nudges
   One single pop-up per session, three possible triggers, by priority:
   3. CART    a deck was added to the cart   -> 5 s later or on exit intent
   2. PRODUCT a deck page, empty cart        -> 10 s later or on exit intent
   1. SITE    any other page, empty cart     -> 10 s later or on exit intent
   Never shown to someone already heading to checkout.
--------------------------------------------------------------------------- */
(function () {
  window.__kanvaNudge = 'loaded';

  var CART = {
    'business-plan-deck': {
      en: {
        badge: 'You\u2019re one move away',
        title: 'You have already made the first move.',
        text: 'You\u2019re one step away from turning your idea into a plan you can actually use.',
        cta: 'Get my Business Plan Deck \u2192',
        keep: 'Continue browsing',
        tag: 'Brainstorm. Challenge. Build. Move.'
      },
      nl: {
        badge: 'Nog \u00e9\u00e9n stap',
        title: 'Je hebt de eerste stap al gezet.',
        text: 'Nog \u00e9\u00e9n stap en je zet je idee om in een plan waarmee je echt verder kunt.',
        cta: 'Bestel mijn Business Plan Deck \u2192',
        keep: 'Verder kijken',
        tag: 'Brainstorm. Challenge. Build. Move.'
      }
    },
    'presentations-deck': {
      en: {
        badge: 'You\u2019re one move away',
        title: 'Your story is ready to move.',
        text: 'One more step and your ideas become a pitch people understand and remember.',
        cta: 'Get my Presentations Deck \u2192',
        keep: 'Continue browsing',
        tag: 'Story. Proof. Flow. Move.'
      },
      nl: {
        badge: 'Nog \u00e9\u00e9n stap',
        title: 'Je verhaal is er. Nu de pitch.',
        text: 'Nog \u00e9\u00e9n stap en je idee\u00ebn worden een pitch die mensen begrijpen \u00e9n onthouden.',
        cta: 'Bestel mijn Presentations Deck \u2192',
        keep: 'Verder kijken',
        tag: 'Story. Proof. Flow. Move.'
      }
    }
  };

  var PRODUCT = {
    'business-plan-deck': {
      en: {
        badge: 'Make the first move',
        title: 'Ideas fade. Plans move.',
        text: 'Everything you need to turn your idea into a business plan is in one deck, with an AI Consultant to challenge you card after card. Start this week and you will have something concrete to show.',
        cta: 'Add the Business Plan Deck',
        keep: 'Keep reading',
        tag: 'Brainstorm. Challenge. Build. Move.'
      },
      nl: {
        badge: 'Zet de eerste stap',
        title: 'Idee\u00ebn vervagen. Plannen bewegen.',
        text: 'Alles om je idee om te zetten in een businessplan zit in een deck, met een AI Consultant die je kaart na kaart scherp houdt. Begin deze week en je hebt iets concreets om te tonen.',
        cta: 'Voeg het Business Plan Deck toe',
        keep: 'Verder lezen',
        tag: 'Brainstorm. Challenge. Build. Move.'
      }
    },
    'presentations-deck': {
      en: {
        badge: 'Make the first move',
        title: 'Your next presentation can land.',
        text: 'A clear structure, the right questions and an AI Consultant to sharpen the story. One deck, and your next pitch stops being a pile of slides.',
        cta: 'Add the Presentations Deck',
        keep: 'Keep reading',
        tag: 'Story. Proof. Flow. Move.'
      },
      nl: {
        badge: 'Zet de eerste stap',
        title: 'Je volgende presentatie kan raak zijn.',
        text: 'Een heldere structuur, de juiste vragen en een AI Consultant om het verhaal aan te scherpen. Een deck, en je volgende pitch is geen stapel slides meer.',
        cta: 'Voeg het Presentations Deck toe',
        keep: 'Verder lezen',
        tag: 'Story. Proof. Flow. Move.'
      }
    }
  };

  var SITE = {
    en: {
      badge: 'Make the first move',
      title: 'Stop planning in your head.',
      text: 'Kanva turns what is in your head into a business plan you can actually use, card after card, with an AI Consultant included. Pick up where thinking stops.',
      cta: 'Discover the Business Plan Deck',
      keep: 'Maybe later',
      tag: 'Think. Build. Move.'
    },
    nl: {
      badge: 'Zet de eerste stap',
      title: 'Stop met plannen in je hoofd.',
      text: 'Kanva zet wat in je hoofd zit om in een businessplan waar je echt verder mee kan, kaart na kaart, met een AI Consultant inbegrepen. Ga verder waar het denken stopt.',
      cta: 'Ontdek het Business Plan Deck',
      keep: 'Misschien later',
      tag: 'Think. Build. Move.'
    }
  };

  // Limited promo line. Hidden automatically once the promo is over.
  var PROMO = {
    en: '<b>Now at -50%</b> EUR 79.95 <s>EUR 159.95</s> until 15 October',
    nl: '<b>Nu -50%</b> EUR 79,95 <s>EUR 159,95</s> tot 15 oktober'
  };
  var PROMO_END = new Date(2026, 9, 15, 23, 59, 59);

  var DELAY = { cart: 5000, product: 10000, site: 10000 };
  var PRIORITY = { site: 1, product: 2, cart: 3 };
  var KEY = 'kanva_nudge_shown';

  var CSS = [
    '.kn-ov{position:fixed;inset:0;background:rgba(51,61,78,.6);opacity:0;visibility:hidden;transition:opacity .3s ease,visibility .3s ease;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:24px}',
    '.kn-ov.is-open{opacity:1;visibility:visible}',
    '.kn{background:#fff;border-radius:20px;max-width:840px;width:100%;box-shadow:0 30px 80px rgba(51,61,78,.35);transform:translateY(16px) scale(.985);transition:transform .3s cubic-bezier(.2,.8,.3,1);position:relative;overflow:hidden;display:grid;grid-template-columns:1.15fr .85fr}',
    '.kn-ov.is-open .kn{transform:translateY(0) scale(1)}',
    '.kn__x{position:absolute;top:14px;right:14px;width:34px;height:34px;border:0;background:rgba(255,255,255,.75);color:#6b7280;font-size:20px;line-height:1;cursor:pointer;border-radius:50%;z-index:2}',
    '.kn__x:hover{background:#fff;color:#333d4e}',
    '.kn__body{padding:40px 36px}',
    '.kn__badge{display:inline-block;background:#488d7e;color:#fff;font-size:11px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;padding:6px 12px;border-radius:99px;margin-bottom:18px}',
    '.kn__title{font-size:30px;line-height:1.18;font-weight:700;color:#333d4e;margin:0 0 14px;letter-spacing:-.01em}',
    '.kn__text{font-size:16px;line-height:1.6;color:#4a5567;margin:0 0 26px}',
    '.kn__promo{display:block;background:#fff6e0;border:1px solid #f2b01e;border-radius:10px;padding:10px 14px;margin:0 0 18px;font-size:15px;color:#333d4e;line-height:1.4}',
    '.kn__promo b{font-weight:700}',
    '.kn__promo s{color:#8a93a2;font-weight:400;margin-left:2px}',
    '.kn__cta{display:block;width:100%;text-align:center;padding:17px 20px;border-radius:12px;font-size:16px;font-weight:700;cursor:pointer;border:0;background:#f2b01e;color:#333d4e;text-decoration:none;box-shadow:0 6px 18px rgba(242,176,30,.35)}',
    '.kn__cta:hover{background:#ffc23d;color:#333d4e}',
    '.kn__ghost{display:block;width:100%;text-align:center;padding:12px 20px;margin-top:10px;background:none;border:0;color:#6b7280;font-size:14px;font-weight:600;cursor:pointer;text-decoration:underline;text-underline-offset:3px}',
    '.kn__ghost:hover{color:#333d4e}',
    '.kn__tag{margin:20px 0 0;font-size:13px;font-weight:700;letter-spacing:.05em;color:#3c619e;text-transform:uppercase}',
    '.kn__media{background:#f0f4f5;display:flex;align-items:center;justify-content:center;padding:24px}',
    '.kn__media img{max-width:100%;max-height:340px;object-fit:contain;display:block}',
    '@media (max-width:760px){.kn-ov{align-items:flex-end;padding:0}.kn{grid-template-columns:1fr;border-radius:20px 20px 0 0;max-height:94vh;overflow-y:auto}.kn__media{order:-1;padding:18px}.kn__media img{max-height:150px}.kn__body{padding:24px 22px 26px}.kn__title{font-size:24px}.kn__text{font-size:15px;margin-bottom:20px}}'
  ].join('');

  var timer = null, pending = null, done = false, ov = null, els = {}, cartFilled = false;

  function seen() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function locale() {
    var l = (window.Shopify && window.Shopify.locale) ? String(window.Shopify.locale).toLowerCase() : '';
    if (l.indexOf('nl') === 0) return 'nl';
    if (l.indexOf('en') === 0) return 'en';
    return window.location.pathname.indexOf('/nl') === 0 ? 'nl' : 'en';
  }

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return r.charAt(r.length - 1) === '/' ? r.slice(0, -1) : r;
  }

  function build() {
    if (ov) return;
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    ov = document.createElement('div');
    ov.className = 'kn-ov';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.hidden = true;
    ov.innerHTML =
      '<div class="kn">' +
        '<button type="button" class="kn__x" aria-label="Close">&times;</button>' +
        '<div class="kn__body">' +
          '<span class="kn__badge"></span>' +
          '<h2 class="kn__title"></h2>' +
          '<p class="kn__text"></p>' +
          '<p class="kn__promo" hidden></p>' +
          '<a class="kn__cta"></a>' +
          '<button type="button" class="kn__ghost"></button>' +
          '<p class="kn__tag"></p>' +
        '</div>' +
        '<div class="kn__media"><img alt=""></div>' +
      '</div>';
    document.body.appendChild(ov);

    els.badge = ov.querySelector('.kn__badge');
    els.title = ov.querySelector('.kn__title');
    els.text = ov.querySelector('.kn__text');
    els.promo = ov.querySelector('.kn__promo');
    els.cta = ov.querySelector('.kn__cta');
    els.keep = ov.querySelector('.kn__ghost');
    els.tag = ov.querySelector('.kn__tag');
    els.img = ov.querySelector('.kn__media img');
    els.x = ov.querySelector('.kn__x');

    els.x.addEventListener('click', close);
    els.keep.addEventListener('click', close);
    els.cta.addEventListener('click', function (e) {
      if (els.cta.getAttribute('data-add') !== '1') return;
      e.preventDefault();
      close();
      var btn = addButton();
      if (btn) setTimeout(function () { btn.click(); }, 320);
    });
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ov && ov.classList.contains('is-open')) close();
    });
  }

  function close() {
    if (!ov) return;
    ov.classList.remove('is-open');
    setTimeout(function () { ov.hidden = true; }, 300);
    document.documentElement.style.overflow = '';
  }

  function show() {
    if (!pending || done || seen()) return;
    var t = pending.copy[locale()] || pending.copy.en;
    done = true;
    markSeen();
    clear();
    build();
    els.badge.textContent = t.badge;
    els.title.textContent = t.title;
    els.text.textContent = t.text;
    els.cta.textContent = t.cta;
    els.keep.textContent = t.keep;
    els.tag.textContent = t.tag;
    if (pending.image) { els.img.src = pending.image; els.img.alt = t.title; }
    if (new Date() <= PROMO_END) {
      els.promo.innerHTML = PROMO[locale()] || PROMO.en;
      els.promo.hidden = false;
    } else {
      els.promo.hidden = true;
    }
    if (pending.type === 'cart') {
      els.cta.setAttribute('data-add', '0');
      els.cta.setAttribute('href', root() + '/checkout');
    } else if (pending.type === 'product') {
      els.cta.setAttribute('data-add', '1');
      els.cta.setAttribute('href', '#');
    } else {
      els.cta.setAttribute('data-add', '0');
      els.cta.setAttribute('href', root() + '/products/business-plan-deck');
    }
    ov.hidden = false;
    void ov.offsetWidth;
    ov.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function clear() { if (timer) { clearTimeout(timer); timer = null; } }
  function cancel() { clear(); pending = null; }

  function arm(type, copy, image) {
    if (done || seen() || !copy) return;
    if (pending && PRIORITY[pending.type] > PRIORITY[type]) return;
    pending = { type: type, copy: copy, image: image };
    clear();
    timer = setTimeout(show, DELAY[type]);
  }

  // Never interrupt someone who is already heading to checkout
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a,button,input[type=submit]') : null;
    if (!el || (ov && ov.contains(el))) return;
    var href = el.getAttribute ? (el.getAttribute('href') || '') : '';
    var name = el.getAttribute ? (el.getAttribute('name') || '') : '';
    var cls = (typeof el.className === 'string') ? el.className : '';
    if (href.indexOf('/checkout') !== -1 || name === 'checkout' || /checkout/i.test(cls)) cancel();
  }, true);

  // Exit intent on desktop
  document.addEventListener('mouseout', function (e) {
    if (!pending || done) return;
    if (e.relatedTarget || e.toElement) return;
    if (e.clientY > 12) return;
    show();
  });

  function bigger(url) {
    if (!url || typeof url !== 'string') return url;
    if (url.indexOf('cdn.shopify.com') === -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=700';
  }

  function handleFromPath() {
    var m = window.location.pathname.match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  function pageImage() {
    var og = document.querySelector('meta[property="og:image"]');
    if (og && og.content) return og.content;
    var img = document.querySelector('.product-gallery img, product-gallery img, main img');
    return img ? (img.currentSrc || img.src) : null;
  }

  function addButton() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var b = forms[i].querySelector('button[type=submit],button[name=add],button');
      if (b && !b.disabled && b.offsetParent !== null) return b;
    }
    return null;
  }

  /* ---- Trigger 3: a deck was added to the cart ---- */
  function fromResponse(data) {
    if (!data) return;
    var item = (data.items && data.items.length) ? data.items[0] : data;
    if (!item) return;
    var handle = item.handle || null;
    if (!handle && item.url) {
      var m = String(item.url).match(/\/products\/([^?#\/]+)/);
      if (m) handle = m[1];
    }
    if (!handle || !CART[handle]) return;
    var img = item.image || null;
    if (!img && item.featured_image) img = item.featured_image.url || item.featured_image;
    arm('cart', CART[handle], bigger(img));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button,input[type=submit]') : null;
    if (!btn || (ov && ov.contains(btn))) return;
    if (btn.getAttribute && btn.getAttribute('name') === 'checkout') return;
    var form = btn.closest ? btn.closest('form') : null;
    var action = (form && form.getAttribute) ? (form.getAttribute('action') || '') : '';
    if (action.indexOf('/cart/add') === -1) return;
    var h = handleFromPath();
    if (h && CART[h]) arm('cart', CART[h], bigger(pageImage()));
  }, true);

  // Simple wrapper. No getter/setter: a getter that always returns our wrapper
  // makes any later script that does "var orig = window.fetch; window.fetch = f(orig)"
  // recurse into itself forever.
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function () {
    var url = arguments[0];
    if (url && url.url) url = url.url;
    var isAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    var p = nativeFetch.apply(this, arguments);
    if (isAdd && p && p.then) {
      p.then(function (res) {
        try { res.clone().json().then(fromResponse).catch(function () {}); } catch (e) {}
        return res;
      }).catch(function () {});
    }
    return p;
  };

  var xopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      this.addEventListener('load', function () {
        try { fromResponse(JSON.parse(this.responseText)); } catch (e) {}
      });
    }
    return xopen.apply(this, arguments);
  };

  /* ---- Triggers 2 and 1: nobody has added anything yet ---- */
  function armBrowsing() {
    if (cartFilled || done || seen()) return;
    var h = handleFromPath();
    if (h && PRODUCT[h]) {
      arm('product', PRODUCT[h], bigger(pageImage()));
      return;
    }
    if (h) return; // another product page, no copy written for it
    if (/\/(cart|checkout|account|policies|challenge)/.test(window.location.pathname)) return;
    nativeFetch(root() + '/products/business-plan-deck.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var img = p && (p.featured_image || (p.images && p.images[0]));
        arm('site', SITE, bigger(img));
      })
      .catch(function () { arm('site', SITE, null); });
  }

  function start() {
    nativeFetch(root() + '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartFilled = !!(c && c.item_count > 0);
        armBrowsing();
      })
      .catch(armBrowsing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Legacy KANVA code, isolated so that a failure here cannot stop the rest. */
try {
   class CartVat extends HTMLElement {
              constructor() {
                  super();

              }

     connectedCallback() {
           this.checkbox = this.querySelector('#invoiceCheckbox');
           this.form = this.querySelector('#invoice-form');

                  this.checkbox.addEventListener('change', () => {
                      if (this.checkbox.checked) {
                          this.show();
                      } else {
                          this.hide();
                      }
                  });
     }



              show() {
                  this.form.classList.remove('hidden');
              }

              hide() {
                  this.form.classList.add('hidden');
              }
          }

          customElements.define('cart-vat', CartVat);
} catch (e) { console.warn('cart-vat init skipped', e); }
